/* eslint-disable no-console */
/* eslint-disable max-len */
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React, { useContext, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Loading from '../../../components/Common/Loaders/FullWidthLoader/Loading';
import { LanguageContext } from '../../../libs/Context';
import { existFolder, restoreFolder } from '../../actions/media_actions';
import useFetchTrash from '../customHooks/useFetchTrash';

const RestorePopup = (props:any) =>
{
	const { popups, restoreData, handlePopup } = props;
	const { language } = useContext(LanguageContext);
	const userData = useSelector((state:any) => state.mysession.session);
	const [ loading, setLoading ] = useState<boolean>(false);
	const [ exist, setExist ] = useState<boolean>(false);
	const getTrashDataInfo = useFetchTrash();

	const handleClose = () =>
	{
		handlePopup({ restore: false });
	};

	const queryParam: any = {
		uid     : userData?.userId,
		comid   : userData?.companyId,
		empRole : userData?.empRole,
		role    : userData?.role
	};

	const restored = restoreData?.map((item:any) =>
	{
		return {

			folderId : item?.folderId,
			type     : item?.type,
			name     : item?.name,
			ownerId  : item?.ownerId,
			parent   : exist ? '' : item?.parentPath?.length > 0 ? item?.parentPath : ''
		};
	});

	const Restore = async () =>
	{
		setLoading(true);

		const body:any = {
			trashData : restored
		};

		if (exist)
		{
			body.child = true;
		}
		try
		{
			const res = await restoreFolder(queryParam, body);

			if (res?.status)
			{
				toast.success(language?.restoreFolder, {
					position  : toast.POSITION.TOP_RIGHT,
					className : 'toast-message'
				});
				handleClose();
				getTrashDataInfo();
				setLoading(false);
			}
		}
		catch (err:any)
		{
			console.log(err);
			setLoading(false);
		}
	};

	const ExistFolder = async () =>
	{
		setLoading(true);

		const body = {
			trashIds : [ restored[0]?.folderId ]
		};

		const query = Object.assign(queryParam, { actionType: 'restore' });

		try
		{
			const check = await existFolder(query, body);

			if (check?.status)
			{
				check?.canRestore?.length > 0
					? Restore()
					: setExist(true);

				setLoading(false);
			}
		}
		catch (err)
		{
			console.log(err);
			setLoading(false);
		}
	};

	return (
		<>
			<Dialog
				open={popups?.restore}
				aria-labelledby='alert-dialog-title'
				aria-describedby='alert-dialog-description'
				fullWidth
				maxWidth='sm'
			>
				<DialogTitle>
					{exist ? language?.info : `${language?.restore} ${restored?.length} ${language?.trashFile}` }
				</DialogTitle>
				<DialogContent>
					{loading && <Loading />}
					{ exist ? language?.restoreConfirmation : language?.restorePolicyPopup}
				</DialogContent>

				<DialogActions>
					<Button
						color='primary'
						disableElevation
						disableFocusRipple
						disableRipple
						disableTouchRipple
						tabIndex={0}
						onKeyUp={(e) => { e.key === 'Enter' && handleClose(); }}
						onClick={handleClose}
					>
						{exist ? language?.no : language.cancel}
					</Button>
					<Button
						variant='contained'
						color='primary'
						className='whiteTxt'
						disableElevation
						disableFocusRipple
						disableRipple
						disableTouchRipple
						tabIndex={0}
						onKeyUp={(e) => { e.key === 'Enter' && (exist ? Restore() : ExistFolder()); }}
						onClick={exist ? Restore : ExistFolder}
					>
						{exist ? language?.yes : language?.restore}
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};

export default RestorePopup;